export default __webpack_public_path__ + "static/media/img-fast-avow-6.970a8251.jpg";